import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import  companiesUrl from "src/assets/companies.json"
import { catchError, map, tap } from 'rxjs/operators';

interface SupportedCitiesResponse {
  supportedCities: { name: string; country: string }[];
}

@Injectable({
  providedIn: 'root',

})

export class AgentService {

  // Define the BehaviorSubject and observable
  private agentCountrySubject = new BehaviorSubject<string | null>(null);

  agentCountry$: Observable<string | null> = this.agentCountrySubject.asObservable();

  private modalMessageSubject = new ReplaySubject<any>(1);
  private jsonDataSubject = new BehaviorSubject<any>(null);
  public leadSubject = new BehaviorSubject<any>(null);  // New code
  private keycloakToken: string | null = null;
  private agentId: number;
  private agentCountry: string | null = null;
  private agentIdAppareil: string; 
  // Expose the leadSubject as a public observable
  // public leadSubject$ = this.leadSubject.asObservable();



  private externalDataUrl = `${environment.BACK_LEADS_SERVICE}/Leads/getleadbyfbreference`;
 
  private backendupdatedUrl = `${environment.BACK_LEADS_SERVICE}/Leads/receive`;

  private nextLeadReference = `${environment.BACK_LEADS_SERVICE}/Leads/nextlead`;

  private locationsUrl = `${environment.BACK_LEADS_SERVICE}/locations`;

  private backendApiUrlForCallInitiation = `${environment.BACK_LEADS_SERVICE}/initiatephonecallbyagent`;

  private backendApiUrlForCallEnd = `${environment.BACK_LEADS_SERVICE}/endphonecallbyagent`;

  private backendApiUrlforCallRecordByAgent = `${environment.BACK_LEADS_SERVICE}/voicerecord-by-agent`;

  private backendReleaseUrl = `${environment.BACK_LEADS_SERVICE}/Leads/release`;

  private backendSkipLeadURL = `${environment.BACK_LEADS_SERVICE}/Leads/skip`;

  private backendStatusForAgentsURL = `${environment.BACK_LEADS_SERVICE}/agents/status`;

  supportedCities: any[] | undefined;

   // Define a subject to emit update status
   private updateStatusSubject = new Subject<boolean>();
   // Expose an observable to subscribe to update status
   updateStatus$ = this.updateStatusSubject.asObservable();



  constructor(private http: HttpClient, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      const fbleadreference = params['fbleadreference'];
      if (fbleadreference) {
        this.loadLeadDetails(fbleadreference);
      }
    });
  }


  getActiveCompany(){
   return companiesUrl.find(company => company.active === true) ;
  }

  getModalMessage(): ReplaySubject<any> {
    return this.modalMessageSubject;
  }

  openModal(message: string , status? : boolean): void {
    this.modalMessageSubject.next({ message : message , status :status});
  }

  closeModal(): void {
    this.modalMessageSubject.next(null); // Emit null when closing the modal
  }

  jsonData$: Observable<any> = this.jsonDataSubject.asObservable();
  lead$: Observable<any> = this.leadSubject.asObservable();  // New code

  

  loadLeadDetails(fbleadreference: string): void {
    const urlWithParams = `${this.externalDataUrl}?fbleadreference=${fbleadreference}`;
    this.http.get<any>(urlWithParams)
      .subscribe(
        data => {
          console.log('External Data loaded:', data);
        
          this.leadSubject.next(data);  // New code
          this.jsonDataSubject.next(data);
        },
        error => {
          console.error('Failed to load External Data:', error);
        }
      );
  }

  getSupportedCities(): any[] | undefined {
    return this.supportedCities;
  }



  // updateJsonData(updatedData: any): void {
  
  //   this.http.put<any>(this.backendupdatedUrl, updatedData)
  //     .subscribe(
  //       response => {
  //         console.log('Data sent to the backend:', response);
  //         this.jsonDataSubject.next(updatedData);
  //       },
  //       error => {
  //         console.error('Failed to send data to the backend:', error);
  //       }
  //     );
  // }

  updateJsonData(updatedData: any): void {
    this.http.put<any>(this.backendupdatedUrl, updatedData)
      .subscribe(
        response => {
          console.log('Data sent to the backend:', response);
          // Emit true to indicate successful update
          this.updateStatusSubject.next(true);
        },
        error => {
          console.error('Failed to send data to the backend:', error);
          // Emit false to indicate failed update
          this.updateStatusSubject.next(false);
        }
      );
  }

 // Method to load the next lead from the backend

  // getNextLead(): Observable<string> {  // Specify the return type
  //   return this.http.get<string>(this.nextLeadReference, { responseType: 'text' as 'json' }); // Set response type to 'text'
  // }
  
  // Method to load the next lead from the backend based on the countries selected by the agent
  // getNextLead(selectedCountries: string[]): Observable<string> {
  //   return this.http.post<string>(
  //     this.nextLeadReference,
  //     { countries: selectedCountries },
  //     { responseType: 'text' as 'json' } // Keep this if the response is plain text
  //   );
  // }

  // getNextLead(selectedCountries: string[]): Observable<string> {
  //   return this.http.post<string>(
  //     this.nextLeadReference,
  //     // { countries: selectedCountries },
  //     selectedCountries,
  //     {
  //       headers: { 'Content-Type': 'application/json' }, // Explicitly set the Content-Type
  //       responseType: 'text' as 'json' // Keep this if the response is plain text
  //     }
  //   );
  // }

  getNextLead(selectedCountries: string[], selectedStatuses: string[] = [],selectedCompanyIds?: string[],  daysRangeToBackend?: number | null): Observable<string> {
    // Prepare the request payload
    const payload: { countries: string[], statuses?: string[], companyIds?:  string[] , daysAgo?: number | null   } = {
      countries: selectedCountries
    };

    // Add statuses only if they are selected (optional)
    if (selectedStatuses.length > 0) {
      payload.statuses = selectedStatuses;
    }

    // Add companyId to the payload if it's provided
  if (selectedCompanyIds) {
    payload.companyIds = selectedCompanyIds
  }

  if (daysRangeToBackend !== undefined) {
    payload.daysAgo = daysRangeToBackend;
  }

    console.log("Payload being sent to the backend:", payload);

    return this.http.post<string>(
      this.nextLeadReference,
      payload, // Send the payload with countries and optionally statuses
      {
        headers: { 'Content-Type': 'application/json' }, // Explicitly set the Content-Type
        responseType: 'text' as 'json' // Keep this if the response is plain text
      }
    );
}
  

    // Method to set the Keycloak token
    setKeycloakToken(token: string) {
      this.keycloakToken = token;
    }
  
    // Method to get the Keycloak token
    getKeycloakToken(): string | null {
      return this.keycloakToken;
    }
  
    // Other existing methods...
    getUserAgentId(userLogin: string): Observable<any> {
      return this.http.get(`${environment.BACK_LEADS_SERVICE}/Agents/get-agent-by-email/${userLogin}`, {
        headers: { Authorization: 'Bearer ' + this.getKeycloakToken() } // Use the token here
      });
    }
  
    saveAgentHistory(agentHistory: any): Observable<any> {
      return this.http.post(`${environment.BACK_LEADS_SERVICE}/Agents/saveagenthistory`, agentHistory, {
        headers: { Authorization: 'Bearer ' + this.getKeycloakToken() } // Use the token here
      });
    }

    setAgentId(id: number): void {
      this.agentId = id;
    }
  
    // Method to get the agent ID
    getAgentId(): number {
      return this.agentId;
    }

    setAgentIdAppareil(id: string): void {
      this.agentIdAppareil = id;
    }
    
    // Method to get the agent ID Appareil
    getAgentIdAppareil(): string {
      return this.agentIdAppareil;
    }
    
    // Method to set the agent country
  setAgentCountry(country: string) {
    this.agentCountrySubject.next(country);
  }

  // Method to get the observable of agent country
  getAgentCountry(): Observable<string | null> {
    return this.agentCountry$;
  }

//  // Method to get locations by multiple countries
// getLocationsByCountries(countries: string[]): Observable<any> {
//   const url = `${this.locationsUrl}`;  // No need for a country path parameter
//   const params = new HttpParams().set('countries', countries.join(','));
//   return this.http.get<any>(url, { params });
// }

getLocationsByCountries(countries: string[]): Observable<any> {
  const url = `${this.locationsUrl}`;  // Base URL for your endpoint

  // Initialize HttpParams and append each country as a separate 'countries' parameter
  let params = new HttpParams();
  countries.forEach(country => {
    params = params.append('countries', country);  // Append each country as a separate 'countries' param
  });

  return this.http.get<any>(url, { params });
}

private phoneNumberSearchQuerySubject = new BehaviorSubject<string | null>(null);
phoneNumberSearchQuery$ = this.phoneNumberSearchQuerySubject.asObservable();

// Method to set the phone number search query
setPhoneNumberSearchQuery(searchQuery: string): void {
  this.phoneNumberSearchQuerySubject.next(searchQuery);
}

// Method to get the current phone number search query
getPhoneNumberSearchQuery(): Observable<string | null> {
  return this.phoneNumberSearchQuery$;
}

 // Call the backend to search for a lead by phone number
 searchLeadByPhoneNumber(phoneNumber: string): Observable<any> {
  const url = `${environment.BACK_LEADS_SERVICE}/search-lead-by-phone`;
  const params = new HttpParams().set('phoneNumber', phoneNumber);
  return this.http.get<any>(url, { params });
}

resetPhoneNumberSearchQuery(): void {
  this.phoneNumberSearchQuerySubject.next(null);
}

// Fetch lead history
getLeadHistoryForSearchResults(fbLeadReference: string): Observable<any[]> {
  const url = `${environment.BACK_LEADS_SERVICE}/search-lead-by-phone/history`;
  const params = new HttpParams().set('fbLeadReference', fbLeadReference);
  return this.http.get<any[]>(url, { params: params });
}

sendCallDataByAgent(id_agent: string, tel: string): Observable<any> {
  const body = { id_agent, tel}; 
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  return this.http.post(this.backendApiUrlForCallInitiation, body, { headers });
}

endCallDataByAgent(id_agent: string, tel: string): Observable<any> {
  const body = { id_agent, tel }; 
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  return this.http.post(this.backendApiUrlForCallEnd, body, { headers });
}

// Method to release the lead by calling the backend API
releaseLead(leadReference: string): Observable<any> {
  return this.http.post(this.backendReleaseUrl, { leadReference }); // Use the release URL
}

getLeadsStatusForAgents(daysAgo: number): Observable<any> {
  const params = new HttpParams().set('daysAgo', daysAgo.toString());
  return this.http.get<any>(this.backendStatusForAgentsURL, { params });
}

skipLead(fbLeadReference: string): Observable<any> {
  const params = new HttpParams().set('fbLeadReference', fbLeadReference);
  return this.http.put(this.backendSkipLeadURL, null, { params, responseType: 'text' }).pipe(
    tap(() => console.log(`Lead skipped with reference: ${fbLeadReference}`)),
  );
}

}